
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useProject } from "@/contexts/ProjectContext";
import NavBar from "@/components/NavBar";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { StageWorkflow } from "@/components/stage-workflow";

export default function StageDetail() {
  const { stageId } = useParams();
  const navigate = useNavigate();
  const { currentProject } = useProject();
  
  const stageIdNumber = stageId ? parseInt(stageId) : 0;
  
  useEffect(() => {
    if (!currentProject) {
      navigate("/dashboard");
    }
  }, [currentProject, navigate]);

  if (!currentProject) {
    return <div>Loading...</div>;
  }

  const stage = currentProject.stages.find(s => s.id === stageIdNumber);
  
  if (!stage) {
    return (
      <div className="min-h-screen flex flex-col">
        <NavBar />
        <div className="container py-8 flex-1 flex flex-col items-center justify-center">
          <h1 className="text-2xl font-bold mb-4">Stage not found</h1>
          <Button onClick={() => navigate("/dashboard")}>
            <ArrowLeft className="mr-2 h-4 w-4" /> Return to Dashboard
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      
      <main className="container py-6 flex-1">
        <div className="flex items-center gap-4 mb-6">
          <Button variant="outline" onClick={() => navigate("/dashboard")}>
            <ArrowLeft className="mr-2 h-4 w-4" /> Back to Dashboard
          </Button>
          <div>
            <h1 className="text-3xl font-bold">{stage.name}</h1>
            <p className="text-muted-foreground">
              {stage.description}
            </p>
          </div>
        </div>
        
        <StageWorkflow 
          project={currentProject} 
          stage={stage} 
          onUpdate={() => {
            // Refresh data if needed
          }} 
        />
      </main>
    </div>
  );
}
